import { Selector } from '@ngxs/store';
import { WarehouseState, WarehouseStateModel } from './warehouse.state';

export class WarehouseStateSelectors {
  @Selector([WarehouseState])
  static getState(state: WarehouseStateModel): WarehouseStateModel {
    return state;
  }
}
